export const storage = {
  get(key) {
    try {
      const data = localStorage.getItem(key)
      return data ? JSON.parse(data) : null
    } catch {
      return localStorage.getItem(key)
    }
  },
  
  set(key, value) {
    localStorage.setItem(key, JSON.stringify(value))
  },
  
  remove(key) {
    localStorage.removeItem(key)
  },
  
  clear() {
    localStorage.clear()
  }
}

export const tokenStorage = {
  get: () => storage.get('token'),
  set: (token) => storage.set('token', token),
  remove: () => storage.remove('token'),
  has: () => !!storage.get('token')
}

export const userStorage = {
  get: () => storage.get('userInfo'),
  set: (user) => storage.set('userInfo', user),
  remove: () => storage.remove('userInfo')
}

export const snStorage = {
  get: () => storage.get('sn'),
  set: (sn) => storage.set('sn', sn),
  remove: () => storage.remove('sn')
}

export const nfcStorage = {
  get: () => storage.get('nfcSign'),
  set: (nfc) => storage.set('nfcSign', nfc),
  remove: () => storage.remove('nfcSign')
}

export const mbtiStorage = {
  get: () => storage.get('mbti'),
  set: (mbti) => storage.set('mbti', mbti),
  remove: () => storage.remove('mbti')
}

export const emailStorage = {
  get: () => storage.get('emailToken'),
  set: (emailToken) => storage.set('emailToken', emailToken),
  remove: () => storage.remove('emailToken')
}